import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useThemes } from './useThemes';
import { ThemeId, isThemeId } from '../constants/themes';

/** L'accueil n'est pas un thème : il pioche dans tous les lots. */
export const HOME_SELECTION = 'home';

export type FeedSelection = typeof HOME_SELECTION | ThemeId;

/**
 * Ce que la colonne de gauche a sélectionné, partagé avec la grille.
 *
 * La sélection vit dans l'URL (`/?theme=...`), ce qui permet de la changer
 * depuis n'importe quelle page — y compris /vote, qui n'affiche pas de grille —
 * et rend le lien partageable. Sans paramètre, on est sur l'Accueil.
 */
export const useSelectedTheme = () => {
  const { themes } = useThemes();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const fromUrl = searchParams.get('theme');
  const selection: FeedSelection =
    fromUrl && isThemeId(fromUrl) ? fromUrl : HOME_SELECTION;

  const select = useCallback((next: FeedSelection) => {
    navigate(next === HOME_SELECTION ? '/' : `/?theme=${next}`);
  }, [navigate]);

  return { selection, themes, select };
};
